<template>
  <div class="dashboard-container">
    <aside class="sidebar">
      <nav class="nav-menu">
        <router-link to="/dashboard/overview" class="nav-item">
          数据总览
        </router-link>
        <router-link to="/dashboard/bracelets" class="nav-item">
          终端管理
        </router-link>
        <router-link to="/dashboard/tags" class="nav-item">
          标签管理
        </router-link>
        <router-link to="/dashboard/base-stations" class="nav-item">
          基站管理
        </router-link>
        <router-link to="/dashboard/map-management" class="nav-item">
          地图管理
        </router-link>
        <router-link to="/dashboard/notifications" class="nav-item">
          通知系统
        </router-link>
      </nav>
    </aside>
    <main class="content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: 'UserDashboard'
};
</script>

<style scoped>
.dashboard-container {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: 240px;
  background-color: #2c3e50;
  padding: 20px;
}

.nav-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.nav-item {
  color: #fff;
  text-decoration: none;
  padding: 10px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.nav-item:hover {
  background-color: #34495e;
}

.nav-item.router-link-exact-active {
  background-color: #1abc9c;
}

.content {
  flex: 1;
  padding: 20px;
  background-color: #f5f6f8;
}
</style>
